import { useEffect } from "react"

import { useAppSelector } from "app/hooks"
import { selectUser } from "store/auth/authSlice"

export const FirstRenderLogic = () => {
  const user = useAppSelector(selectUser)

  useEffect(() => {
    if (user?.userId) {
      // eslint-disable-next-line no-void
      void (async () => {
        const { mixpanelClient } = await import("services/mixpanel/mixpanel")
        mixpanelClient.IDENTIFY(user.userId)
      })()
    }
  }, [user?.userId])

  return null
}
